import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import palette from '../../../../utilities/palette';
import { DotFlashing } from '../../../styledComponents/Components.styles';
import { StyledConfirmButton } from '../../../styledComponents/Buttons.styles';
import { CircularProgress } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '550px',
  height: '410px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const confirmationStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '480px',
  height: '250px',
  bgcolor: 'background.paper',
  border: `2px solid ${palette.main}`,
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
};

// Helper component for auto-scrolling to bottom
const AlwaysScrollToBottom = () => {
  const elementRef = React.useRef(undefined);
  React.useEffect(() => elementRef.current.scrollIntoView());
  return <div ref={elementRef} />;
};

// Confirmation page component
const ConfirmationPage = ({ setModalType, handleSubmit, setIsProcessingSubmit, dryRun }) => {
  const handleYesClick = (e) => {
    setModalType("submit");
    handleSubmit(e);
  };

  const handleNoClick = () => {
    setIsProcessingSubmit(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-evenly', color: palette.main }}> 
      <div style={{ alignSelf: 'center', fontSize: '24px', fontWeight: '500', display: 'flex', flexDirection: 'row', height: '100px' }}>
        {dryRun ? 'Validation Confirmation' : 'Submission Confirmation'}
      </div>
      <div style={{ alignSelf: 'center', fontSize: '18px', fontWeight: '450', height: '80px'}}>
        {dryRun ? 'No SRPd will be submitted or published. Proceed?' : 'The form will no longer be editable. Proceed?'}
      </div>
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly'}}>
        <StyledConfirmButton 
          confirmType="yes"
          type='button' 
          onClick={handleYesClick}>
          Yes
        </StyledConfirmButton>
        <StyledConfirmButton     
          backgroundColor={palette.stepper.error}
          confirmType="no"
          type='button' 
          onClick={handleNoClick}>
          No
        </StyledConfirmButton>
      </div>
    </div>
  );
};

// Submit page component
const SubmitPage = ({ submitStatus, statusDisplay, dryRun }) => {
  const renderStatusItems = () => {
    return Object.keys(statusDisplay).map((key) => {
      if (!statusDisplay[key]) return null;
      
      return (
        <div
          style={{
            padding: '5px 10px',
            fontSize: '14px',
          }}
          key={key}>
          {statusDisplay[key]}
        </div>
      );
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', height: '100%' }}>
      <div style={{ alignSelf: 'center', fontSize: '24px', fontWeight: '500', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', color: palette.main }}>
        <span>{dryRun ? 'Validation in progress' : 'Submission in progress'}</span>
        <DotFlashing size="medium" />
      </div>



      <CircularProgress style={{width: '50px', height: '50px', color: palette.main}}/>
      <div style={{ alignSelf: 'center', fontSize: '20px', fontWeight: '450', marginTop: '10px' }}>
        Do <span style={{ color: 'crimson' }}>NOT</span> close this window.
      </div>

      {/* <div style={{alignSelf: 'center'}}>
        <p style={{marginTop: '5px', marginBottom:'5px'}}>Logs:</p>
        <div style={{
          height: '230px',
          width: '410px',
          overflow: 'scroll',
          border: '1px solid #ccc',
        }}
          id="logs"
        >
          {submitStatus !== "" && (
            <div
              style={{
                padding: '5px 10px',
                fontSize: '14px',
                color: palette.stepper.error,
              }}>
              {submitStatus}
            </div>
          )}
          {renderStatusItems()}
          <AlwaysScrollToBottom />
        </div>
      </div> */}
    </div>
  );
};



// Helper function to create delay promise
const createDelay = (ms: number) => {
  return new Promise((resolve: (value?) => void) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};

export default function SubmitModal({
  dryRun = false,
    modalType,
    setModalType,
    isProcessingSubmit,
    setIsProcessingSubmit,
    handleSubmit,
    statusDisplay,
    submitStatus,
}) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const syncState = async () => {
      const shouldDelay = modalType !== 'confirm' && isProcessingSubmit === false;
      
      if (shouldDelay) {
        await createDelay(2000);
      }

      setOpen(isProcessingSubmit);
    };

    syncState();
  }, [isProcessingSubmit, modalType]);

  const renderModalContent = () => {
    if (modalType === "confirm") {
      return (
        <ConfirmationPage 
          dryRun={dryRun}
          setModalType={setModalType}
          handleSubmit={handleSubmit}
          setIsProcessingSubmit={setIsProcessingSubmit}
        />
      );
    }
    
    return (
      <SubmitPage 
        dryRun={dryRun}
        submitStatus={submitStatus}
        statusDisplay={statusDisplay}
      />
    );
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}      
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={confirmationStyle}>
            {renderModalContent()}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}